import { ChartMeasures, RetentionChartMeasures } from './ChartMeasures';
import ChartGroups from './ChartGroups';
import { CHART_TYPES } from '../constants/chartTypes';
import { IBreakdownOverallStatus } from '../../../utils/interfaces';
import CompactChartGroups from './CompactChartGroups';
import { useCurrentUrl } from '../../../utils/routing';
import ThinDivider from '../../ThinDivider';
import { useChartContext } from '../ChartContext';

interface IProps {
  analysisId: string;
}
export default ({ analysisId }: IProps) => {
  const {
    displayedSlices,
    metadata: { isBreakdownOverall },
    settings: { chartSettings },
    displayedMeasures,
  } = useChartContext();
  const { singleDayLabel, chartType } = chartSettings;

  const { isReportInUrl } = useCurrentUrl();

  const hasSlices =
    displayedSlices.length > 0 &&
    // XXX we do show the slices in the IBreakdownOverallStatus.NoBreakdownCompare case
    isBreakdownOverall !== IBreakdownOverallStatus.NoBreakdown &&
    chartType !== CHART_TYPES.GEO_MAP;

  const showRetentionMeasure =
    [CHART_TYPES.RETENTION_BAR, CHART_TYPES.RETENTION_LINE].includes(
      chartType,
    ) && !singleDayLabel;

  const hasMeasures = showRetentionMeasure || displayedMeasures.length > 0;

  if (!hasMeasures && !hasSlices) {
    return null;
  }

  return (
    <>
      {showRetentionMeasure ? (
        <RetentionChartMeasures analysisId={analysisId} />
      ) : (
        <ChartMeasures analysisId={analysisId} />
      )}
      {hasSlices && (
        <>
          <ThinDivider layout="horizontal" size="full" />
          {/* PATH is a special case where we don't want to show the compact chart groups
          since we need the replace group action in Dashboard */}
          {isReportInUrl || chartType === CHART_TYPES.PATH ? (
            <ChartGroups analysisId={analysisId} />
          ) : (
            <CompactChartGroups analysisId={analysisId} />
          )}
        </>
      )}
    </>
  );
};
